import { gql } from './apollo';

export const GET_GC_CARD_INVENTORIES_FOR_PROPERTY = gql`
    query ($offset: Int = 0, $limit: Int = 10, $filter: [GraphQLFilter]) {
        table(
            name: "gc_card_inventory"
            filter: $filter
            contain: [
                {
                    table: "propertyuser__c"
                    alias: "created_by_propertyuser__c"
                    columns: ["name"]
                    fk: "id"
                    joinFk: "created_by"
                    limit: 1
                }
            ]
            orderBy: "date"
            orderByDirection: DESC
            offset: $offset
            limit: $limit
        )
    }
`;

export const GET_DISTINCT_REASONS_FOR_PROPERTY = gql`
    query ($property__c_id: MultiTypeInput!) {
        table(
            name: "gc_card_inventory"
            columns: ["reason_for_activation"]
            filter: [
                { left: "property__c_id", right: $property__c_id, expression: "=" }
                { left: "reason_for_activation", expression: "IS NOT NULL" }
            ]
            limit: 1000
        )
    }
`;

export const CREATE_GC_CARD_INVENTORY = gql`
    mutation (
        $property__c_id: MultiTypeInput
        $created_by: MultiTypeInput
        $date: MultiTypeInput
        $card_number: MultiTypeInput
        $serial_number: MultiTypeInput
        $activation_date: MultiTypeInput
        $card_type: MultiTypeInput
        $num_cards: MultiTypeInput
        $initial_value: MultiTypeInput
        $current_balance: MultiTypeInput
        $expiry_date: MultiTypeInput
        $reason_for_activation: MultiTypeInput
        $notes: MultiTypeInput
    ) {
        createRow(
            table: "gc_card_inventory"
            values: [
                { property: "property__c_id", value: $property__c_id }
                { property: "created_by", value: $created_by }
                { property: "date", value: $date }
                { property: "card_number", value: $card_number }
                { property: "serial_number", value: $serial_number }
                { property: "activation_date", value: $activation_date }
                { property: "card_type", value: $card_type }
                { property: "num_cards", value: $num_cards }
                { property: "initial_value", value: $initial_value }
                { property: "current_balance", value: $current_balance }
                { property: "expiry_date", value: $expiry_date }
                { property: "reason_for_activation", value: $reason_for_activation }
                { property: "notes", value: $notes }
            ]
        )
    }
`;

export const UPDATE_GC_CARD_INVENTORY_BALANCE = gql`
    mutation ($id: String!, $current_balance: MultiTypeInput) {
        updateRow(
            table: "gc_card_inventory"
            id: $id
            values: [{ property: "current_balance", value: $current_balance }]
        )
    }
`;

export const DELETE_GC_CARD_INVENTORY = gql`
    mutation ($id: String!) {
        deleteRow(table: "gc_card_inventory", id: $id)
    }
`;
